



















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import SideNavVue from "../components/SideNav.vue";
import ChooseAssitVue from "../components/ChooseAssit.vue";
import ChooseSubjectVue from "../components/ChooseSubject.vue";
import MonthSelectorVue from "../components/MonthSelector.vue";
import version from "@/version";
import DimAssitSubVue from "./DimAssitSub.vue";

@Component({
    components: {
        "side-nav": SideNavVue,
        "choose-assit": ChooseAssitVue,
        "choose-subject": ChooseSubjectVue,
        "month-selector": MonthSelectorVue,
        "dim-sub": DimAssitSubVue,
    },
})
export default class AssistingSubsidiaryLedger extends Vue {
    @Prop({ type: Number })
    subjectId?: number;

    @Prop({ type: Number })
    dimItemId?: number;

    @Prop({ type: Boolean })
    isDialog?: boolean;

    @Prop({ type: String })
    longText?: string;

    @Prop({ type: Array })
    appointDate?: Date[];

    @Prop({ type: Object })
    dimRelation?: Assist.Relation;

    // 辅助余额表传来的辅助核算类别名称
    @Prop({ type: String })
    assistType!: string;

    showNum: boolean = false;

    tableData: Subsidiary[] = [];
    subjectVal: Subject.Subject | null = null;
    assistVal: Subject.Subject | null = null;
    currentAccountTypeName: string = "项目"; //辅助明细账的类别名
    //改变时间
    period: String[] = []; // 日期
    changeDate(date: string[]) {
        this.period = date;
        this.fetchData();
    }
    // 选择科目
    changeSubject(val: Subject.Subject) {
        this.subjectVal = val;
        this.fetchData();
    }
    //选择Assist
    changeAssist(val: Subject.Subject) {
        this.assistVal = val;
        this.subjectVal = null;
        (<ChooseSubjectVue>this.$refs.subjectSelect).getSubjects(() => {
            this.fetchData();
        });
    }
    // 打开凭证号 的模态框
    dialogVoucher: boolean = false;
    openDialogVoucher(data: Subsidiary) {
        if (data.voucherId != -1) {
            this.dialogVoucher = true;
            this.$nextTick(function () {
                let comVoucher: any = this.$refs.voucher;
                comVoucher.isDialog = true;
                comVoucher.isEdit = true;
                comVoucher.shouldGetInit = false;
                comVoucher.showSaveAndAdd = false;
                comVoucher.showAdd = false;
                comVoucher.getSubjectList(
                    data.date.replace(/-/, "").substring(0, 6),
                    () => {
                        Vue.axios
                            .post(`voucher/` + data.voucherId + `/find`, {
                                id: 123,
                            })
                            .then(res => {
                                comVoucher.packVoucher(res.data);
                                comVoucher.isEdit = true;
                                comVoucher.showSaveAndAdd = false;
                                comVoucher.showAdd = false;
                            });
                    }
                );
            });
        }
    }
    //获取table内容的值
    fetchData() {
        this.tableData = [];
        if (this.isDialog) {
            let type = this.transRelation(this.assistType);
            let relation = this.dimRelation
            // let relation: any = {};
            // relation.subjectId = this.subjectId;
            // relation[type] = this.dimItemId;
            Vue.axios
                .post(`dim/subsidiaryledgers/getlist`, {
                    accountBookId: this.$store.state.accountBook.id,
                    currentAccountTypeName: this.assistType,
                    subjectId: this.subjectId,
                    startPeriod: this.period[0],
                    endPeriod: this.period[1],
                    relation: relation,
                })
                .then(res => {
                    this.tableData = res.data;
                    this.subjectVal = null;
                });
        } else {
            let subId = this.subjectVal === null ? null : this.subjectVal.id;
            if (this.subjectVal && this.period.length > 0 && this.assistVal !== null) {
                Vue.axios
                    .post(`dim/subsidiaryledgers/getlist`, {
                        accountBookId: this.$store.state.accountBook.id,
                        currentAccountTypeName: this.currentAccountTypeName,
                        subjectId: subId,
                        startPeriod: this.period[0],
                        endPeriod: this.period[1],
                        relation: this.getRelation(),
                    })
                    .then(res => {
                        this.tableData = res.data;
                        // 切换日期时 this.subjectVal = null不能重新获取数据
                        // this.subjectVal = null;
                    });
            }
        }
    }
    getRelation() {
        let obj: any = {};
        if (this.assistVal || this.subjectVal) {
            if (this.assistVal && !this.subjectVal) {
                let attr = this.transRelation(this.currentAccountTypeName);
                obj[attr] = this.assistVal.id;
            } else if (!this.assistVal && this.subjectVal) {
                obj.subjectId = this.subjectVal.id;
                let attr = this.transRelation(this.currentAccountTypeName);
                obj[attr] = null;
            } else if (this.assistVal && this.subjectVal) {
                let attr = this.transRelation(this.currentAccountTypeName);
                obj[attr] = this.assistVal.id;
                obj.subjectId = this.subjectVal.id;
            }
        }
        return obj;
    }

    transRelation(val: string) {
        switch (val) {
            case "项目":
                return "dimItemId";
            case "客户":
                return "dimCustomerId";
            case "部门":
                return "dimDepartmentId";
            case "员工":
                return "dimEmployeeId";
            case "存货":
                return "dimInventoryId";
            case "供应商":
                return "dimProviderId";
            case "dimItemId":
                return "项目";
            case "dimCustomerId":
                return "客户";
            case "dimDepartmentId":
                return "部门";
            case "dimEmployeeId":
                return "员工";
            case "dimInventoryId":
                return "存货";
            case "dimProviderId":
                return "供应商";
            default:
                return "dimItemId";
        }
    }
    // 下载
    id: number = 0;
    downLoad() {
        if (this.assistVal) {
            if (this.assistVal.id) this.id = this.assistVal.id;
        }
        let subId:string | number = "";
        if (this.subjectVal) {
            if (this.subjectVal.id) subId = this.subjectVal.id;
        }
        let dimAccountId = this.id || 0;
        let url = `${Vue.axios.defaults.baseURL}export/subsidiaryledger/dim?accountBookId=${this.$store.state.accountBook.id}&subjectId=${subId}&dimAccountType=${this.currentAccountTypeName}&dimAccountId=${dimAccountId}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&token=${this.$store.state.account.token}&version=${version}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }

    pdfDownLoad() {
        if (this.assistVal) {
            if (this.assistVal.id) this.id = this.assistVal.id;
        }
        let subId:string | number = "";
        if (this.subjectVal) {
            if (this.subjectVal.id) subId = this.subjectVal.id;
        }
        let dimAccountId = this.id || 0;
        let url = `${Vue.axios.defaults.baseURL}export/pdf/subsidiaryledger/dim/num?accountBookId=${this.$store.state.accountBook.id}&subjectId=${subId}&dimAccountType=${this.currentAccountTypeName}&dimAccountId=${dimAccountId}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&token=${this.$store.state.account.token}&version=${version}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
}
